import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import Header from '../parts/Header'
import ApiSubHeader from '../parts/ApiSubHeader'
import * as MyAPI from '../../../utils/MyAPI'
import * as AbstructedApi from '../../../utils/AbstructedApi'
import * as UserActions from '../../../actions/UserActions'
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';

// ApiManagerTop
const ApiManagerTop = (props) => {

  let navigate = useNavigate();
  let dispatch = useDispatch();
  
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  });
  let subscription_status = useSelector(state => {
    if (state.user && state.user.subscription_status) {
      return state.user.subscription_status
    } else {
      return 'unknown'
    }
  });

  let [loading, setLoading] = useState(false);
  // let [subscriptionStatus, setSubscriptionStatus] = useState("unknown");

  // componentDidMount
  useEffect(() => {
    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = async () => {

    if (!login_token) {
      // redirect
      navigate("/dashboard")
      return;
    }

    // check subscription status
    if (subscription_status === "unknown") {
      let _obj = await AbstructedApi.checkSubscriptionStatus(login_token)
      dispatch(UserActions.setSubscriptionStatus({
        subscription_status: _obj.subscription_status,
      }))
    }

  }

  // componentDidMount
  useEffect(() => {
    // _firstScript()

    if (subscription_status === "active") {
      navigate("/api_usage")
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscription_status]);

  return (
    <div>

      <Header />

      <ApiSubHeader />

      {/* main */}
      <Container style={{
        marginTop: 40,
      }}>

        <Row style={{
          marginTop: 20,
          marginBottom: 20,
        }}>
          <Col md="12" xs="12" style={{
            textAlign: 'right',
          }}>
            <span>
              APIキーの発行にはサブスクリプションの設定が必要です。
              <br/>
              毎月最初の60分は無料、固定費もありません。いつでもキャンセルできます。
              <br/>
              <br/>
              <Link to="/payment_add">
                サブスクリプションの設定へ
              </Link>
            </span>
          </Col>
        </Row>

      </Container>

      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default ApiManagerTop
